import type { RunVercelResult, VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { PROVISION_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { runVercel } from '../runner/run-vercel.js'
import { createdStoreId } from './created-store-id.js'

/** `delete-store` runs a full env pull over `.env.local` afterwards; the flow's `guardEnvLocal` covers it. */
export async function deleteOrphanStore(
  runner: VercelRunner,
  cwd: string,
  createResult: RunVercelResult,
  env?: NodeJS.ProcessEnv
): Promise<void> {
  const storeId = createdStoreId(createResult)
  if (!storeId) return
  await runVercel(runner, ['blob', 'delete-store', storeId, '--yes'], {
    cwd,
    mode: 'capture',
    timeoutMs: PROVISION_TIMEOUT_MS,
    env
  })
}
